// extracted by mini-css-extract-plugin
export var acitonButtons = "_ew-0";
export var additionalIcon = "_ew-f";
export var block = "_ew-1";
export var blockContent = "_ew-7";
export var blockDescription = "_ew-8";
export var blockIcon = "_ew-9";
export var blockTitle = "_ew-6";
export var border = "_ew-a";
export var center = "_ew-l";
export var edge = "_ew-b";
export var edgeLabel = "_ew-c";
export var edgePath = "_ew-d";
export var error = "_ew-e";
export var flowchart = "_ew-g";
export var flowchartContent = "_ew-h";
export var highlighted = "_ew-3";
export var hover = "_ew-4";
export var icon = "_ew-i";
export var left = "_ew-m";
export var navButton = "_ew-j";
export var navButtons = "_ew-k";
export var right = "_ew-n";
export var selected = "_ew-2";
export var small = "_ew-5";